document.addEventListener("DOMContentLoaded", async function () {
  const grid = document.getElementById("instagram-sales-grid");
  const loadMoreWrap = document.getElementById("instagram-sales-load-more");

  let currentPage = 1;
  let totalPages = 1;
  let isLoading = false;

  /* ---------- FETCH + RENDER PAGE ---------- */
  async function fetchInstagramSales(page = 1, append = false) {
    if (isLoading) return;
    isLoading = true;

    try {
      if (loadMoreWrap) {
        loadMoreWrap.innerHTML = `<button class="instagram-load-more-btn loading">Loading...</button>`;
      }

      const response = await fetch(
        `https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/get-instagram-sales?page=${page}`
      );

      const result = await response.json();

      if (!result.sales) {
        if (!append) {
          grid.innerHTML = "<p>No showcase data found.</p>";
        }
        return;
      }

      totalPages = result.pagination?.total_pages || 1;

      let html = "";

      Object.entries(result.sales).forEach(([id, item]) => {
        let slidesHTML = "";
        let dotsHTML = "";

        item.gallery.forEach((media, index) => {
          const type = media[0];
          const url = media[1];
          const activeClass = index === 0 ? "active" : "";

          if (type === "image") {
            slidesHTML += `
              <div class="slide ${activeClass}" data-slide="${index}">
                <img src="${url}" alt="${item.creation}" class="showcase-image" data-showcase-id="${id}">
              </div>
            `;
          }

          if (type === "video") {
            slidesHTML += `
              <div class="slide ${activeClass}" data-slide="${index}">
                <video controls class="showcase-video" data-showcase-id="${id}" preload="metadata" autoplay muted loop playsinline>
                  <source src="${url}" type="video/mp4">
                </video>
              </div>
            `;
          }

          dotsHTML += `<span class="dot ${activeClass}" data-slide="${index}"></span>`;
        });

        html += `
          <div class="single-showcase grid-item" data-showcase-id="${id}">
            <div class="single-showcase-media">
              <div class="image-slider">
                <div class="slider-container">
                  ${slidesHTML}
                </div>

                ${
                  item.gallery.length > 1
                    ? `
                    <button class="slider-arrow prev" type="button">&#10094;</button>
                    <button class="slider-arrow next" type="button">&#10095;</button>
                    <div class="slider-dots">${dotsHTML}</div>
                  `
                    : ""
                }
              </div>
            </div>

            <div class="single-showcase-meta" data-showcase-id="${id}">
              <div class="single-showcase-author">
                <span class="author_name">Gemstones For Sale</span>
              </div>

              <div class="showcase-creation-title">${item.creation || ""}</div>

              <div class="showcase-creation-story">
                ${item.creation_story || ""}
              </div>

              <div class="showcase-creation-other">
                ${
                  item.collection_url
                    ? `<a href="${item.collection_url}" class="inquire_now">Explore More</a>`
                    : ""
                }
                <span class="inquire_now">Inquire Now</span>
              </div>
            </div>
          </div>
        `;
      });

      if (append) {
        grid.insertAdjacentHTML("beforeend", html);
      } else {
        grid.innerHTML = html;
      }

      initSliders();

      /* LOAD MORE BUTTON */
      if (loadMoreWrap) {
        if (currentPage < totalPages) {
          loadMoreWrap.innerHTML = `
            <button id="load-more-instagram-sales" class="instagram-load-more-btn" type="button">
              Show More
            </button>
          `;
        } else {
          loadMoreWrap.innerHTML = "";
        }
      }
    } catch (error) {
      console.error("Error loading showcase:", error);

      if (!append) {
        grid.innerHTML = "<p>Failed to load showcase data.</p>";
      }
    } finally {
      isLoading = false;
    }
  }

  /* ---------- SLIDER ---------- */
  function initSliders() {
    document.querySelectorAll(".single-showcase").forEach(showcase => {
      if (showcase.dataset.sliderInitialized === "true") return;
      showcase.dataset.sliderInitialized = "true";

      const slides = showcase.querySelectorAll(".slide");
      const dots = showcase.querySelectorAll(".dot");
      const prevBtn = showcase.querySelector(".prev");
      const nextBtn = showcase.querySelector(".next");

      if (!slides.length) return;

      let currentSlide = 0;
      let isThrottled = false;

      function showSlide(index) {
        slides.forEach((slide, i) => {
          slide.classList.toggle("active", i === index);

          const video = slide.querySelector("video");
          if (video) {
            if (i === index) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          }
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle("active", i === index);
        });

        currentSlide = index;
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          showSlide((currentSlide + 1) % slides.length);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          showSlide((currentSlide - 1 + slides.length) % slides.length);
        });
      }

      dots.forEach(dot => {
        dot.addEventListener("click", function (e) {
          e.stopPropagation();
          showSlide(parseInt(this.dataset.slide));
        });
      });

      /* MOBILE SCROLL SLIDE */
      showcase.addEventListener(
        "wheel",
        function (e) {
          if (window.innerWidth > 767 || slides.length <= 1) return;

          if (isThrottled) return;

          isThrottled = true;

          if (e.deltaY > 0) {
            showSlide((currentSlide + 1) % slides.length);
          } else {
            showSlide((currentSlide - 1 + slides.length) % slides.length);
          }

          setTimeout(() => {
            isThrottled = false;
          }, 500);
        },
        { passive: true }
      );
    });
  }

  /* ---------- INITIAL LOAD ---------- */
  await fetchInstagramSales(currentPage);

  /* ---------- SHOW MORE ---------- */
  document.addEventListener("click", async function (e) {
    const loadMoreBtn = e.target.closest("#load-more-instagram-sales");

    if (loadMoreBtn) {
      if (currentPage < totalPages) {
        currentPage++;
        await fetchInstagramSales(currentPage, true);
      }
      return;
    }

    /* ---------- POPUP OPEN ---------- */
    const meta = e.target.closest(".single-showcase-meta .inquire_now");

    if (meta && meta.tagName.toLowerCase() !== "a") {
      const showcase = meta.closest(".single-showcase");
      if (!showcase) return;

      const creationStory =
        showcase.querySelector(".showcase-creation-title")?.textContent.trim() || "";

      const modal = document.querySelector("#PopupModal-gfs-contact-us-form");
      if (!modal) return;

      modal.setAttribute("open", "");
      modal.classList.add("active");

      const dialog = modal.querySelector('[role="dialog"]');
      if (dialog) dialog.focus();

      const productTitle = modal.querySelector(".product-Title");
      if (productTitle) {
        productTitle.textContent = creationStory;
      }

      const productName = modal.querySelector("input[name='product_name']");
      if (productName) {
        productName.value = creationStory;
      }

      document.body.classList.add("overflow-hidden");
      return;
    }

    /* ---------- CLOSE POPUP ---------- */
    const modal = document.querySelector("#PopupModal-gfs-contact-us-form");

    if (modal && modal.hasAttribute("open")) {
      const dialogContent = modal.querySelector(".product-popup-modal__content");

      if (
        !e.target.closest(".single-showcase-meta .inquire_now") &&
        dialogContent &&
        !dialogContent.contains(e.target)
      ) {
        closePopup();
      }
    }
  });

  /* ---------- ESC CLOSE ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closePopup();
    }
  });

  function closePopup() {
    const modal = document.querySelector("#PopupModal-gfs-contact-us-form");
    if (!modal) return;

    modal.removeAttribute("open");
    modal.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }

  /* ---------- PRODUCT CONTACT FORM ---------- */
  const productContactForm = document.getElementById("product--contact-form");

  if (productContactForm) {
    productContactForm.addEventListener("submit", async function (e) {
      e.preventDefault();

      const form = e.target;
      const formData = new FormData(form);

      const emailInput = document.getElementById("client_email");
      const email = emailInput?.value.trim() || "";

      const errorMsg = document.getElementById("email-error");
      if (errorMsg) errorMsg.style.display = "none";

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(email)) {
        if (errorMsg) errorMsg.style.display = "block";
        alert("Please enter a valid email address.");
        return;
      }

      if (productContactForm.classList.contains("submitting")) return;
      productContactForm.classList.add("submitting");

      const loader = document.querySelector("#product--contact-form .loader");
      const formActions = document.querySelector("#product--contact-form .form-actions");
      const productInfo = document.querySelector("#product--contact-form .product-information");
      const formFields = document.querySelector("#product--contact-form #product--contact-form");
      const thankYou = document.querySelector("#product--contact-form .thank-you-message");

      if (loader) loader.style.display = "block";
      if (formActions) formActions.style.display = "none";

      try {
        const response = await fetch(
          "https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/exclusive-inquiry",
          {
            method: "POST",
            body: formData,
          }
        );

        const result = await response.json();

        if (result.error) {
          alert("Error: " + result.error);

          if (loader) loader.style.display = "none";
          if (formActions) formActions.style.display = "flex";

          productContactForm.classList.remove("submitting");
          return;
        }

        if (!result.inquiry_id) {
          alert("Something went wrong. Inquiry ID is missing.");

          if (loader) loader.style.display = "none";
          if (formActions) formActions.style.display = "flex";

          productContactForm.classList.remove("submitting");
          return;
        }

        if (formActions) formActions.style.display = "none";
        if (productInfo) productInfo.style.display = "none";
        if (formFields) formFields.style.display = "none";
        if (loader) loader.style.display = "none";
        if (thankYou) thankYou.style.display = "block";

      } catch (error) {
        console.error("Submission failed:", error);

        alert("Something went wrong. Please try again.");

        if (loader) loader.style.display = "none";
        if (formActions) formActions.style.display = "flex";
      } finally {
        productContactForm.classList.remove("submitting");
      }
    });
  }
});